/*
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd. All rights reserved.
This file contains Protected Intellectual Property owned by Kaleida Ltd and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (explicitly not developed by Kaleida), whether or not such application forms part of the Platform.
For the avoidance of doubt, the inclusion of any application within the Platform does not of itself grant any right to use Protected Intellectual Property in that application unless that application was developed by Kaleida.
*/

// IP-NOTICE: PROTECTED
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
	selector: 'collapsible-form-region',
	templateUrl: './collapsible-form-region.component.html',
	styleUrls: ['./collapsible-form-region.component.scss'],
	standalone: false,
})
export class CollapsibleFormRegionComponent implements OnInit {
	@Input() expanded = false;
	@Input() hasContent = true;
	@Input() showCopyButton = false;
	@Output() expandedChange = new EventEmitter<boolean>();

	@Input() startTabIndex = 1;
	@Input() headerText: string;
	@Input() bodyText: string;
	@Output() copyClicked = new EventEmitter();

	@Input() hasError: boolean = false;

	get headerTextEmpty(): boolean {
		return this.headerText == null || this.headerText.trim().length === 0;
	}

	get bodyTextEmpty(): boolean {
		return this.bodyText == null || this.bodyText.trim().length === 0;
	}

	constructor() {}

	ngOnInit() {}

	toggleExpansion() {
		this.expanded = !this.expanded;
		this.expandedChange.emit(this.expanded);
	}

	emitCopy() {
		this.copyClicked.emit();
	}
}
